import "core-js/modules/es7.string.pad-start";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/web.dom.iterable";
import _toConsumableArray from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _defineProperty from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import packageTableMixins from "@/mixins/packageTableMixins";
import logoImg1 from "./images/dianchi1.png";
import logoImg2 from "./images/dianchi2.png";
import logoImg3 from "./images/dianchi3.png";
import DistributionLog from "../devicedistribution/distributionLog1";
import Control from "../control/control.vue";
import Historyrouter from "../historyrouter/historyrouter";
import echarsView2 from "../details/echarsView2.vue";
import AlermDes from "../../alarmManage/alermDes/alermDes2.vue";
import { ChartPie, ChartItemBar, ChartLineStackMul2 } from "_c/charts";
import { get_device4g, get_left_data4g, get_qr_code, get_4g_broken_line, get_danti_view } from "@/api/chuku";
import { get_now_lnglat, get_downloadtoken } from "@/api/jingxiaoshang";
import { commonReq } from "@/api/common";
import * as echarts from "echarts";
export default {
  name: "MechanismManage",
  mixins: [packageTableMixins],
  data: function data() {
    var _ref;

    var now = new Date();
    var startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
    var endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
    return _ref = {
      mosState: null,
      voltage_listRight: null,
      highestRight: null,
      minimumRight: null,
      yachaRight: null,
      averageRight: null,
      timestampsLine: null,
      dianliuLine: null,
      dianliuLine1: null,
      shengyurongliangLine: null,
      yachaLine: null,
      zongdianyaDataLine: null,
      moswendu: null,
      chongdianDataLine: null,
      project_id: null,
      pack_sn: null,
      xunhuan_num: null,
      dianchichuan: null,
      mos_wendu: null,
      now_connect_status: null,
      huanjing_wendu: null,
      chongdianmos: null,
      junheng: null,
      fangdianmos: null
    }, _defineProperty(_ref, "now_connect_status", null), _defineProperty(_ref, "fangdianDataLine", null), _defineProperty(_ref, "huanjingwendu", null), _defineProperty(_ref, "NTC4", null), _defineProperty(_ref, "NTC3", null), _defineProperty(_ref, "NTC2", null), _defineProperty(_ref, "NTC1", null), _defineProperty(_ref, "zongdianya", null), _defineProperty(_ref, "dianliu", null), _defineProperty(_ref, "gonglv", null), _defineProperty(_ref, "manchong_capacity", null), _defineProperty(_ref, "remaining_capacity", null), _defineProperty(_ref, "battery_status", null), _defineProperty(_ref, "qr_url", null), _defineProperty(_ref, "soc", null), _defineProperty(_ref, "hardware_verAll", null), _defineProperty(_ref, "hardware_ver", null), _defineProperty(_ref, "pack_sn", null), _defineProperty(_ref, "chans", null), _defineProperty(_ref, "chansAll", null), _defineProperty(_ref, "did", null), _defineProperty(_ref, "sn", null), _defineProperty(_ref, "values", []), _defineProperty(_ref, "formValidate", {
      city: "",
      date: [startOfDay, endOfDay]
    }), _defineProperty(_ref, "gaugeChart", null), _defineProperty(_ref, "currDidTab", "0"), _defineProperty(_ref, "details_data", ["实时监测预览", "参数设置", "历史记录", "告警数据", "历史轨迹", "密码管理"]), _defineProperty(_ref, "items", [{
      icon: "./images/lingdang.png",
      label: "单体过压",
      linkIcon: "./images/tiaozhuan.png",
      color: "rgba(237, 64, 20, 1)"
    }, {
      icon: "./images/lingdang.png",
      label: "另一个状态",
      linkIcon: "./images/tiaozhuan.png",
      color: "rgba(20, 64, 237, 1)"
    }]), _ref;
  },
  components: {
    ChartPie: ChartPie,
    ChartItemBar: ChartItemBar,
    ChartLineStackMul2: ChartLineStackMul2,
    DistributionLog: DistributionLog,
    AlermDes: AlermDes,
    Control: Control,
    Historyrouter: Historyrouter,
    echarsView2: echarsView2
  },
  methods: {
    change_tab2: function change_tab2(tab) {
      this.currDidTab = tab;
    },
    //背景
    getDianchiStyle: function getDianchiStyle(value) {
      var maxValue = Math.max.apply(Math, _toConsumableArray(this.values));
      var minValue = Math.min.apply(Math, _toConsumableArray(this.values));

      if (value == maxValue) {
        return {
          backgroundImage: "url(".concat(logoImg3, ")") // 最大值背景

        };
      } else if (value == minValue) {
        return {
          backgroundImage: "url(".concat(logoImg2, ")") // 最小值背景

        };
      } else {
        return {
          backgroundImage: "url(".concat(logoImg1, ")") // 其他值背景

        };
      }
    },
    //折线图
    convertLine: function convertLine(value) {
      this.timestampsLine = value.map(function (item) {
        return item.timestamp;
      }); // this.dianliuLine = value.map((item) => Number(item.dianliu));

      this.dianliuLine = value.map(function (item) {
        var dianliuValue = Number(item.dianliu);
        return dianliuValue < 0 ? 0 : dianliuValue;
      });
      this.dianliuLine1 = value.map(function (item) {
        var dianliuValue = Number(item.dianliu);
        return dianliuValue > 0 ? 0 : Math.abs(dianliuValue);
      });
      this.shengyurongliangLine = value.map(function (item) {
        return Number(item.soc);
      });
      this.yachaLine = value.map(function (item) {
        return Number(item.yacha);
      });
      console.log("折线图数据", this.yachaLine);
      this.zongdianyaDataLine = value.map(function (item) {
        return Number(item.zongdianya);
      });
      this.chongdianDataLine = value.map(function (item) {
        return Number(item.chongdianmos);
      });
      this.fangdianDataLine = value.map(function (item) {
        return Number(item.fangdianmos);
      });
      this.moswendu = value.map(function (item) {
        return Number(item.mos_wendu);
      });
      this.huanjingwendu = value.map(function (item) {
        return Number(item.huanjing_wendu);
      });
      this.NTC1 = value.map(function (item) {
        return Number(item.NTC1);
      });
      this.NTC2 = value.map(function (item) {
        return Number(item.NTC2);
      });
      this.NTC3 = value.map(function (item) {
        return Number(item.NTC3);
      });
      this.NTC4 = value.map(function (item) {
        return Number(item.NTC4);
      });
    },
    formatDate: function formatDate(dateString) {
      var date = new Date(dateString);
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, "0"); // 月份从0开始

      var day = String(date.getDate()).padStart(2, "0");
      var hours = String(date.getHours()).padStart(2, "0");
      var minutes = String(date.getMinutes()).padStart(2, "0");
      var seconds = String(date.getSeconds()).padStart(2, "0");
      return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
    },
    //查询
    queryData: function queryData() {
      var _this2 = this;

      this.formValidate.date[0] = this.formatDate(this.formValidate.date[0]);
      this.formValidate.date[1] = this.formatDate(this.formValidate.date[1]);
      console.log("查询", this.formValidate);
      get_4g_broken_line({
        did: this.did,
        chan: this.formValidate.city,
        start_time: this.formValidate.date[0],
        end_time: this.formValidate.date[1]
      }).then(function (res) {
        _this2.mosState = res.body.mos;

        _this2.convertLine(res.body.yunxing_trends);
      });
    },
    todayData: function todayData() {
      var _this3 = this;

      var now = new Date();
      var startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
      var endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
      this.formValidate.date = [this.formatDate(startOfDay), this.formatDate(endOfDay)];
      get_4g_broken_line({
        did: this.did,
        chan: this.formValidate.city,
        start_time: this.formValidate.date[0],
        end_time: this.formValidate.date[1]
      }).then(function (res) {
        _this3.mosState = res.body.mos;

        _this3.convertLine(res.body.yunxing_trends);
      });
    },
    //导出
    exportHistory: function exportHistory() {
      this.formValidate.date[0] = new Date(this.formValidate.date[0]).getTime();
      this.formValidate.date[1] = new Date(this.formValidate.date[1]).getTime();
      get_downloadtoken({
        type: "1"
      }).then(function (res) {
        _this.buttonLoading = false;

        if (res.result === 0) {
          var downloadtoken = res.body.downloadtoken;
          commonReq("/index.php/admin/devicedetail/get_device_type", {
            did: vm.form_filter.did
          }).then(function (res) {
            if (res.result === 0) {
              var lang = localStorage.getItem("local") === "en-US" ? "en-us" : "zh-cn";
              commonReq("/index.php/admin/device/history_daochu?lang=".concat(lang), {
                type: 1,
                downloadtoken: downloadtoken,
                did: vm.form_filter.did,
                time_start: formModel.start_time,
                time_end: formModel.end_time
              }).then(function (res) {
                vm.$Message.success(vm.$t("导出成功"));
                vm.$Modal.remove();
                var routeData = vm.$router.push({
                  path: "/deviceman/downloadlist"
                });
                window.open(routeData.href, "_self");
              }); // }
            }
          });
        } else {
          vm.$Message.error(res.errorMsg);
        }
      });
    },
    tiaozhuan: function tiaozhuan() {
      this.currDidTab = "2";
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    this.did = this.$route.query.did;
    get_device4g({
      did: this.did
    }).then(function (res) {
      get_qr_code({
        did: _this4.did
      }).then(function (res) {
        _this4.qr_url = res.body.qrcode_url;
      });
      _this4.chansAll = res.body.chans;
      _this4.chans = res.body.chans[0];
      _this4.formValidate.city = res.body.chans[0];
      get_4g_broken_line({
        did: _this4.did,
        chan: _this4.formValidate.city,
        start_time: _this4.formatDate(_this4.formValidate.date[0]),
        end_time: _this4.formatDate(_this4.formValidate.date[1])
      }).then(function (res) {
        _this4.mosState = res.body.mos;

        _this4.convertLine(res.body.yunxing_trends);
      });
    });
  },
  destroyed: function destroyed() {}
};